<template>
  <div class="relative w-fit">
    <div
      :class="[
        'relative cursor-pointer px-[12px] py-[7px] pr-[16px] flex flex-row-reverse items-center justify-between w-[188px] rounded bg-white border',
        dropdownOpen ? 'border-grays-800' : 'border-grays-400',
        'text-left group hover:border-grays-600',
      ]"
      @click="toggleDropdown"
    >
      <span
        :class="[
          dropdownOpen ? 'rotate-180 text-grays-800' : '',
          'material-symbols-rounded text-grays-700 group-disabled:text-grays-600 text-[20px]',
        ]"
      >
        expand_more
      </span>
      <div class="flex flex-row-reverse gap-[8px]">
        <span
          class="text-sm text-grays-900 group-disabled:text-grays-600 font-regular"
        >
          {{
            selectedCard.save_card ? selectedCard.save_card.slice(-4) : "****"
          }}
          ****
        </span>
        <card-brand-icon
          :brand="selectedCard.brand"
          size="sm"
          custom-class="group-disabled:opacity-50"
        />
      </div>
    </div>

    <transition
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="dropdownOpen"
        :class="openUp ? 'absolute mb-2 bottom-[40px] mt-0' : ''"
        class="absolute mt-2 max-h-[400px] w-full overflow-auto rounded bg-white text-base shadow-tooltip z-20"
      >
        <div class="flex flex-col py-[12px] pb-[4px]">
          <p class="text-xs text-grays-700 mb-[4px] px-[16px]">כרטיס אשראי</p>
          <div
            v-for="(card, index) in creditCards"
            :key="index"
            class="cursor-pointer px-[16px] card-hover"
            @click="selectCard(card)"
          >
            <div
              class="flex flex-row-reverse min-h-[44px] gap-[8px] items-center justify-end"
            >
              <span class="text-sm text-grays-700 font-regular"
                >****
                {{ card.save_card ? card.save_card.slice(-4) : "****" }}</span
              >
              <card-brand-icon :brand="card.brand" size="sm" />
            </div>
          </div>
          <button
            class="group flex flex-row-reverse px-[16px] min-h-[44px] gap-[16px] items-center justify-end add-card-hover"
            @click="handleAddNewCard"
          >
            <p
              class="text-sm text-primary-700 group-hover:text-primary-800 font-regular"
            >
              הוסף כרטיס אשראי
            </p>
            <span
              class="material-symbols-rounded text-primary-700 text-xl group-hover:text-primary-800"
              >add_card</span
            >
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CardBrandIcon from "@/components/Global/CardBrandIcon.vue";

export default {
  name: "SelectPayment",
  components: {
    CardBrandIcon,
  },
  props: {
    openUp: {
      type: Boolean,
      default: false,
    },
    typeCard: {
      type: String,
      default: "nedarim",
    },
    creditCards: {
      type: Array,
      default: () => [],
    },
    currentCard: {
      type: Object,
      default: () => ({}),
    },
    addCardModal: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      selectedCard: {}, // Leave empty to initialize later
      dropdownOpen: false,
    };
  },
  computed: {
    defaultCard() {
      return (
        this.creditCards.find((card) => card.is_default) ||
        this.creditCards[0] ||
        {}
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      // No automatic selection here to prevent resetting selectedCard
    },
    selectCard(card) {
      if (this.selectedCard.id !== card.id) {
        this.selectedCard = card;
        this.$emit("card-changed", this.selectedCard);
      }
      this.dropdownOpen = false; // Close dropdown after selection
    },
    handleAddNewCard(event) {
      event.preventDefault();
      this.dropdownOpen = false;
      if (!this.addCardModal) {
        this.$emit("closeModal");
        this.$router.push("/payment-methods");
      } else {
        this.$emit("add-new-card");
      }
    },
  },
  watch: {
    currentCard: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.selectedCard = { ...newVal }; // Update selectedCard from currentCard prop
      },
    },
  },
  created() {
    // Initialize selectedCard only once when the component is created
    this.selectedCard = { ...this.currentCard };
  },
  mounted() {
    this._clickOutsideHandler = (event) => {
      if (this.dropdownOpen && !this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    };
    document.addEventListener("click", this._clickOutsideHandler);
  },
  beforeUnmount() {
    document.removeEventListener("click", this._clickOutsideHandler);
  },
};
</script>

<style>
.card-hover:hover {
  background-color: #f2f2f2;
}

.add-card-hover:hover {
  background-color: #f2f2f2;
}
</style>
